export default __webpack_public_path__ + "static/media/1291.6806bad5.png";